

























































import { snakeCase } from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import { SocketNames } from '../../components'
import { CustomConnection } from '../../logic/Connections/CustomConnection'
import CustomEditor from '../../logic/Editor/CustomEditor'
import FlowHelper from '../../logic/Helpers/helper'
import OutputConnectionStatValue from '../Statistics/OutputConnectionStatValue.vue'
import CustomOutput from './CustomOutput'
import FakeSocket from './FakeSocket.vue'
import Socket from './Socket.vue'

@Component({
  name: 'OutputSocket',
  data() {
    return {
      snakeCase,
      FakeSocket,
      SocketNames
    }
  },
  components: {
    Socket,
    OutputConnectionStatValue
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class OutputSocket extends Vue {
  @Prop() output!: CustomOutput

  @Prop() editor!: CustomEditor

  @Prop() bindSocket!: DirectiveBinding

  get hiddenConnections(): Array<CustomConnection> {
    return this.output.connections
      .filter((c) => !c.data.visible)
  }

  get styles(): { [key: string]: string | number } {
    return {
      backgroundColor: `rgba(${ FlowHelper.typeSocketColor(this.output.name) }, 0.3)`,
    }
  }

  mounted(): void {
    this.output.setIsVisible(true)
  }
}
